import {
  AMENDMENT_METHOD,
  AMENDMENT_TYPE,
  AMENDMENT_UNITS,
  JSONSchema7WithErrors,
  RDAmendment,
} from '@cibo/core'
import { pathEq } from 'ramda'
import { ITraitFeatureByIdYear } from '../types'
import { findInitialValuesDetail } from '../utils'
import { AmendmentCell } from './AmendmentCell'
import { AmendmentEditor } from './AmendmentEditor'
import { AmendmentRollup } from './AmendmentRollup'

const TRAIT_ID = 'amendment'

export const Amendment: ITraitFeatureByIdYear<RDAmendment> = {
  traitId: TRAIT_ID,
  cellDisplay: AmendmentCell,
  editor: AmendmentEditor,
  rollups: {
    default: {
      traitId: TRAIT_ID,
      Component: AmendmentRollup,
      detailBaseValue: () => ({
        traitId: TRAIT_ID,
        input: {
          events: [],
        },
      }),
      isRollupValue: pathEq(['input', 'events', 'length'], 0),
    },
  },
  ns: '@cibo/landmanager/AmendmentEditor',

  initialValues: request => {
    const detail = findInitialValuesDetail(TRAIT_ID)(request)

    return detail?.input
      ? {
          events: detail.input.events,
        }
      : {}
  },
  detailFromEditorValues: (values, requirement) => {
    return {
      traitId: TRAIT_ID,
      year: requirement?.year,
      input: values.input,
    }
  },

  validJsonSchema: ({ t }) =>
    ({
      type: 'object',
      properties: {
        events: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              date: { type: 'string', format: 'date' },
              amendmentType: {
                enum: AMENDMENT_TYPE,
                errorMessage: { enum: t('required_amendmentType') },
              },
              nitrogenPercentage: {
                type: 'number',
                minimum: 0,
                maximum: 100,
                errorMessage: {
                  minimum: t('warning_rate'),
                  maximum: t('warning_rate'),
                },
              },
              method: {
                enum: AMENDMENT_METHOD,
                errorMessage: { enum: t('required_method') },
              },
              rate: {
                type: 'number',
                minimum: 1,
                errorMessage: { minimum: t('rateMinimum') },
              },
              units: {
                enum: AMENDMENT_UNITS,
                errorMessage: { enum: t('required_units') },
              },
            },
            required: ['date', 'amendmentType', 'method', 'rate', 'units'],
          },
        },
      },
    } as unknown as JSONSchema7WithErrors),

  warningJsonSchema: ({ t }) => ({
    type: 'object',
    properties: {
      events: {
        type: 'array',
        items: {
          type: 'object',
          properties: { rate: { type: 'number' }, units: { type: 'string' } },
          allOf: [
            {
              if: { properties: { units: { const: 'poundsPerAcre' } } },
              then: {
                properties: {
                  rate: { maximum: 500, errorMessage: { maximum: t('warning_rate') } },
                },
              },
            },
            {
              if: { properties: { units: { const: 'tonsPerAcre' } } },
              then: {
                properties: {
                  rate: { maximum: 50, errorMessage: { maximum: t('warning_rate') } },
                },
              },
            },
            {
              if: { properties: { units: { const: 'gallonsPerAcre' } } },
              then: {
                properties: {
                  rate: { maximum: 8000, errorMessage: { maximum: t('warning_rate') } },
                },
              },
            },
          ],
        },
      },
    },
  }),
}
